import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Logo from "components/Library/Logo";

import styles from "./LogoLink.css";

export default function LogoLink({ tabIndex }) {
  return (
    <a href="/" tabIndex={tabIndex} className={classNames(styles.root)}>
      <div className={styles.logoContainer}>
        <Logo isCompressed={true} />
      </div>
    </a>
  );
}

LogoLink.defaultProps = {
  tabIndex: "0",
};

LogoLink.propTypes = {
  tabIndex: PropTypes.string,
};
